// tRPC v11 client setup
import { createTRPCReact } from '@trpc/react-query';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from '../../../backend/src/routers/index';

/**
 * tRPC React Client
 *
 * Creates typed React hooks for calling backend API.
 * Provides full TypeScript autocomplete and type safety.
 *
 * Usage:
 * - Queries: trpc.inventory.getProducts.useQuery({ locationId: '...' })
 * - Mutations: trpc.inventory.addStock.useMutation()
 */
export const trpc = createTRPCReact<AppRouter>();

export type RouterInputs = inferRouterInputs<AppRouter>;
export type RouterOutputs = inferRouterOutputs<AppRouter>;
